import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';
import BasicGuard from '@/routes/middlewares/BasicGuard';

const AboutPage = lazy(() => import('@/pages/Guide'));
const FlowPage = lazy(() => import('@/pages/Guide/Flow'));
const ToretaPage = lazy(() => import('@/pages/Guide/Toreta'));
const WalletPage = lazy(() => import('@/pages/Guide/Wallet'));
const VotingPage = lazy(() => import('@/pages/Guide/Voting'));
const RaceCardPage = lazy(() => import('@/pages/Guide/RaceCard'));

const ErrorPage = lazy(() => import('@/pages/Error'));

const GuideLayout = lazy(
  () => import('@/components/layouts/Guide/CommonLayout'),
);

export enum GuidePaths {
  About = 'about',
  Flow = 'flow',
  Toreta = 'toreta',
  Wallet = 'wallet',
  Voting = 'voting',
  RaceCard = 'racecard',
}

const GuideRoutes: FC = () => {
  return (
    <Switch>
      <Route path="/" element={<GuideLayout />}>
        <Route
          index
          element={
            <BasicGuard>
              <AboutPage />
            </BasicGuard>
          }
        />
        <Route
          path={GuidePaths.Flow}
          element={
            <BasicGuard>
              <FlowPage />
            </BasicGuard>
          }
        />
        <Route
          path={GuidePaths.Toreta}
          element={
            <BasicGuard>
              <ToretaPage />
            </BasicGuard>
          }
        />
        <Route
          path={GuidePaths.Wallet}
          element={
            <BasicGuard>
              <WalletPage />
            </BasicGuard>
          }
        />
        <Route
          path={GuidePaths.Voting}
          element={
            <BasicGuard>
              <VotingPage />
            </BasicGuard>
          }
        />
        <Route
          path={GuidePaths.RaceCard}
          element={
            <BasicGuard>
              <RaceCardPage />
            </BasicGuard>
          }
        />

        <Route
          path="*"
          element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
        />
      </Route>
    </Switch>
  );
};

export default GuideRoutes;
